// Theme: desert-glass
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'desert-glass',
  name: 'DESERT GLASS',
  tagline: 'DESERT GLASS',
  description: 'Vidro mineral do deserto com contraste quente e seco.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2A2015', '#3A2E1F', '#C4A882', '#F5F0E8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-desert-glass'
  },
  colorVars: {
    '--accent': '#C4A882',
    '--accent-foreground': '#2A2015',
    '--background': '#2A2015',
    '--border': '#8A7050',
    '--card': '#3A2E1F',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F5F0E8',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A2015',
    '--foreground': '#F5F0E8',
    '--hold-fill': '#C4A882',
    '--input': '#8A7050',
    '--modal-bg': '#2A2015',
    '--modal-border': '#8A7050',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A7050',
    '--muted-foreground': '#F5F0E8',
    '--nav-active': '#C4A882',
    '--nav-bg': '#3A2E1F',
    '--popover': '#3A2E1F',
    '--popover-foreground': '#F5F0E8',
    '--primary': '#C4A882',
    '--primary-foreground': '#2A2015',
    '--ring': '#C4A882',
    '--secondary': '#8A7050',
    '--secondary-foreground': '#F5F0E8',
    '--streak': '#C4A882',
    '--success': '#22c55e',
    '--success-foreground': '#2A2015',
    '--xp': '#C4A882',
    '--xp-bg': '#3A2E1F'
  },
  resolvedVars: {
    '--accent': '#C4A882',
    '--accent-foreground': '#2A2015',
    '--accent-foreground-hsl': '31 33% 12%',
    '--accent-foreground-oklch': 'from #2A2015 l c h',
    '--accent-hsl': '35 36% 64%',
    '--accent-oklch': 'from #C4A882 l c h',
    '--background': '#2A2015',
    '--background-hsl': '31 33% 12%',
    '--background-oklch': 'from #2A2015 l c h',
    '--border': '#8A7050',
    '--border-hsl': '33 27% 43%',
    '--border-oklch': 'from #8A7050 l c h',
    '--border-w': '1px',
    '--card': '#3A2E1F',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F5F0E8',
    '--card-foreground-hsl': '37 39% 94%',
    '--card-foreground-oklch': 'from #F5F0E8 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '33 30% 17%',
    '--card-oklch': 'from #3A2E1F l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2A2015',
    '--destructive-foreground-hsl': '31 33% 12%',
    '--destructive-foreground-oklch': 'from #2A2015 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F5F0E8',
    '--foreground-hsl': '37 39% 94%',
    '--foreground-oklch': 'from #F5F0E8 l c h',
    '--hold-fill': '#C4A882',
    '--hold-fill-hsl': '35 36% 64%',
    '--hold-fill-oklch': 'from #C4A882 l c h',
    '--input': '#8A7050',
    '--input-hsl': '33 27% 43%',
    '--input-oklch': 'from #8A7050 l c h',
    '--modal-bg': '#2A2015',
    '--modal-bg-hsl': '31 33% 12%',
    '--modal-bg-oklch': 'from #2A2015 l c h',
    '--modal-border': '#8A7050',
    '--modal-border-hsl': '33 27% 43%',
    '--modal-border-oklch': 'from #8A7050 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A7050',
    '--muted-foreground': '#F5F0E8',
    '--muted-foreground-hsl': '37 39% 94%',
    '--muted-foreground-oklch': 'from #F5F0E8 l c h',
    '--muted-hsl': '33 27% 43%',
    '--muted-oklch': 'from #8A7050 l c h',
    '--nav-active': '#C4A882',
    '--nav-active-hsl': '35 36% 64%',
    '--nav-active-oklch': 'from #C4A882 l c h',
    '--nav-bg': '#3A2E1F',
    '--nav-bg-hsl': '33 30% 17%',
    '--nav-bg-oklch': 'from #3A2E1F l c h',
    '--popover': '#3A2E1F',
    '--popover-foreground': '#F5F0E8',
    '--popover-foreground-hsl': '37 39% 94%',
    '--popover-foreground-oklch': 'from #F5F0E8 l c h',
    '--popover-hsl': '33 30% 17%',
    '--popover-oklch': 'from #3A2E1F l c h',
    '--primary': '#C4A882',
    '--primary-foreground': '#2A2015',
    '--primary-foreground-hsl': '31 33% 12%',
    '--primary-foreground-oklch': 'from #2A2015 l c h',
    '--primary-hsl': '35 36% 64%',
    '--primary-oklch': 'from #C4A882 l c h',
    '--radius': '10px',
    '--ring': '#C4A882',
    '--ring-hsl': '35 36% 64%',
    '--ring-oklch': 'from #C4A882 l c h',
    '--secondary': '#8A7050',
    '--secondary-foreground': '#F5F0E8',
    '--secondary-foreground-hsl': '37 39% 94%',
    '--secondary-foreground-oklch': 'from #F5F0E8 l c h',
    '--secondary-hsl': '33 27% 43%',
    '--secondary-oklch': 'from #8A7050 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#C4A882',
    '--streak-hsl': '35 36% 64%',
    '--streak-oklch': 'from #C4A882 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2A2015',
    '--success-foreground-hsl': '31 33% 12%',
    '--success-foreground-oklch': 'from #2A2015 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(35 36% 64% / 0.15)',
    '--xp': '#C4A882',
    '--xp-bg': '#3A2E1F',
    '--xp-bg-hsl': '33 30% 17%',
    '--xp-bg-oklch': 'from #3A2E1F l c h',
    '--xp-hsl': '35 36% 64%',
    '--xp-oklch': 'from #C4A882 l c h'
  }
}
